export default "__VITE_ASSET__BcXUNEEF__"